/* global axios */
import ApiClient from '../ApiClient';

class AnalysisResults extends ApiClient {
  constructor() {
    super('analysis/results', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export default new AnalysisResults();
